// extracted by mini-css-extract-plugin
export default {"reviewCard":"ReviewCard_reviewCard__Fobbl","reviewUser":"ReviewCard_reviewUser__YVk3k"};